import { N07_01 } from "./N07_01";

export const N07 = {
  columns: 12,
  rows: 2,
  visual: {
    id: 1,
    type: "advancedTable",
    colorTheme: "colorTheme1",
    title: "Coverage by Medical Representative Per Region",
    binding: {
      data: {
        columns: [
          {
            name: "Region",
            columnName: "Region",
            width: "120px",
            align: "left",
            sortable: true,
          },
          {
            name: "Coverage",
            columnName: "Coverage",
            width: "220px",
            align: "center",
            sortable: true,
          },
          {
            name: "Target",
            columnName: "Target",
            width: "150px",
            align: "center",
            sortable: true,
          },
          {
            name: "Coverage %",
            columnName: "CoveragePercent",
            width: "150px",
            align: "center",
            sortable: true,
            percent: true,
          },
          {
            name: "MR Team",
            columnName: "MRTeam",
            width: "170px",
            align: "center",
            sortable: true,
          },
          {
            name: "Working Days",
            columnName: "WorkingDays",
            width: "170px",
            align: "center",
            sortable: true,
          },
          {
            name: "Average Call",
            columnName: "AverageCall",
            width: "170px",
            align: "center",
            sortable: true,
          },
          {
            name: "Target Average Call",
            columnName: "TargetAverageCall",
            width: "200px",
            align: "center",
            sortable: true,
          },
          {
            name: "Actual Team Call",
            columnName: "ActualTeamCall",
            width: "170px",
            align: "center",
            sortable: true,
          },
          {
            name: "Target Team Call",
            columnName: "TargetTeamCall",
            width: "170px",
            align: "center",
            sortable: true,
          },
          {
            name: "Call Rate",
            columnName: "CallRate",
            width: "170px",
            align: "center",
            sortable: true,
            percent: true,
          },
        ],
        title: "Region",
        endpoint: "N07",
        parameters: [
          { key: "FromMonth", value: "CP1" },
          { key: "FromYear", value: "2026" },
          { key: "ToMonth", value: "CP1" },
          { key: "ToYear", value: "2026" },
        ],
      },
      context: {
        point: {
          onClick: N07_01,
        },
      },
    },
  },
};
